
import SubmissionForm from './terrace-submission/SubmissionForm';

const TerraceSubmissionForm = () => {
  return <SubmissionForm />;
};

export default TerraceSubmissionForm;
